export const translations = {
  en: {
    dir: "ltr",
    // Top bar
    top_call: "Call Us",
    top_email: "Email",
    top_hours: "Open 7 Days: 9:00 - 20:00",
    // Nav
    nav: {
      home: "Home",
      about: "About Us",
      gallery: "Gallery",
      hajj: "Hajj Packages",
      hajj_menu: "Hajj",
      hajj_prereg: "Hajj Pre Registration 2027",
      hajj_req: "Hajj Application Requirement",
      hajj_packages: "Hajj Packages 2027",
      umrah: "Umrah Packages",
      custom: "Customize Package",
      halal: "Halal Tours",
      blog: "Blog",
      contact: "Contact",
    },
    book_now: "Book Now",
    get_quote: "Get a Free Quote",
    view_details: "View Details",
    view_all: "View All",
    read_more: "Read More",
    enquire: "Enquire Now",
    // Hero
    hero: {
      eyebrow: "Welcome to Fly Jannah",
      title: "Your Trusted Partner for Hajj & Umrah",
      subtitle:
        "Embark on a spiritually enriching journey to Makkah & Madinah with premium accommodations, dedicated guidance and complete peace of mind.",
      cta1: "Explore Packages",
      cta2: "Watch Our Journey",
    },
    stats: {
      travelers: "Happy Pilgrims",
      success: "Success Rate",
      rating: "Client Rating",
      experience: "Years Experience",
    },
    // About
    about: {
      eyebrow: "Who We Are",
      title: "Elevating the Journey of Faith with Excellence",
      body:
        "Fly Jannah is a leading pilgrimage travel company committed to delivering exceptional, spiritually enriching journeys to the sacred cities of Makkah and Madinah. Built on trust, professionalism and meticulous planning, we transform every Hajj and Umrah into a seamless and memorable experience.",
      points: [
        "Luxury to economy Hajj & Umrah packages",
        "5-star & premium hotels near the Haram",
        "Dedicated visa processing & documentation",
        "24/7 client assistance before & during travel",
        "Professional ground handling & guided services",
        "Trusted partner for families & groups",
      ],
      btn: "More About Us",
    },
    // Sections
    sec: {
      packages_eye: "Choose Your Package",
      packages_title: "Sacred Journeys Crafted For You",
      packages_sub:
        "Thoughtfully designed Hajj & Umrah packages combining comfort, convenience and complete peace of mind.",
      why_eye: "Why Choose Us",
      why_title: "Excellence in Every Sacred Journey",
      why_sub:
        "We combine experience, trust and dedication to deliver a seamless and spiritually fulfilling pilgrimage.",
      halal_eye: "Halal Tours",
      halal_title: "Explore the World, The Halal Way",
      halal_sub:
        "Muslim-friendly holiday destinations with halal food, prayer facilities and family comfort.",
      testi_eye: "Testimonials",
      testi_title: "What Our Pilgrims Say",
      testi_sub:
        "The heartfelt duas and trust of our pilgrims reflect our commitment to excellence.",
      blog_eye: "Our Blog",
      blog_title: "Guidance & Travel Insights",
      blog_sub: "Tips, guides and spiritual insights to prepare you for your sacred journey.",
      affiliations: "Our Trusted Partners",
    },
    why: [
      {
        title: "Enhancing the Experience",
        desc: "From comfortable accommodations near the Haram to organised transport, every detail is managed for your peace of mind.",
      },
      {
        title: "Unparalleled Local Expertise",
        desc: "Strong partnerships in Saudi Arabia ensure reliable ground handling and trusted hotel networks.",
      },
      {
        title: "A Complete One-Stop Solution",
        desc: "From visa processing to hotel reservations and on-ground assistance, we manage everything under one roof.",
      },
      {
        title: "Customize Package",
        desc: "Whether economy, premium or 5-star luxury, we design packages that match your needs and budget.",
      },
    ],
    // CTA
    cta: {
      title: "Create Divine Moments in Hajj & Umrah",
      body: "Experience a spiritually transformative journey where every detail is thoughtfully arranged. Focus entirely on your ibadah and connection with Allah.",
      btn: "Start Your Journey",
    },
    // Package card
    from: "From",
    per_person: "per person",
    days: "Days",
    // Custom package page
    custom: {
      title: "Customize Your Package",
      sub: "Tell us your preferences and our travel experts will craft a personalised Hajj or Umrah package just for you.",
      form: {
        name: "Full Name",
        email: "Email Address",
        phone: "Phone Number",
        type: "Journey Type",
        travelers: "Number of Travelers",
        depart: "Preferred Departure",
        duration: "Duration (Days)",
        hotel: "Hotel Category",
        city: "Departure City",
        budget: "Budget per Person (BDT)",
        message: "Additional Requirements",
        submit: "Submit Request",
      },
      success: "Thank you! Our team will contact you within 24 hours with a personalised quote.",
    },
    // Contact page
    contact: {
      title: "Get in Touch",
      sub: "Have questions about your pilgrimage? Our team is here to help you every step of the way.",
      address: "Address",
      phone: "Phone",
      email: "Email",
      hours: "Working Hours",
      form_title: "Send Us a Message",
      name: "Your Name",
      msg: "Your Message",
      subject: "Subject",
      send: "Send Message",
      success: "Message sent! We will get back to you shortly, InshaAllah.",
    },
    // Footer
    footer: {
      about:
        "Fly Jannah is your trusted partner for a seamless and spiritually enriching Hajj & Umrah journey.",
      quick: "Quick Links",
      packages: "Packages",
      contact: "Contact Info",
      newsletter: "Newsletter",
      newsletter_sub: "Subscribe for the latest packages and travel updates.",
      subscribe: "Subscribe",
      rights: "All rights reserved.",
      made: "Crafted with devotion for every pilgrim.",
    },
    duration: "Duration",
    includes: "What's Included",
    filter_all: "All Packages",
    filter_hajj: "Hajj",
    filter_umrah: "Umrah",
  },

  bn: {
    dir: "ltr",
    top_call: "কল করুন",
    top_email: "ইমেইল",
    top_hours: "সপ্তাহে ৭ দিন খোলা: ৯:০০ - ২০:০০",
    nav: {
      home: "হোম",
      about: "আমাদের সম্পর্কে",
      gallery: "গ্যালারি",
      hajj: "হজ প্যাকেজ",
      hajj_menu: "হজ",
      hajj_prereg: "হজ প্রি-রেজিস্ট্রেশন ২০২৭",
      hajj_req: "হজ আবেদনের শর্তাবলী",
      hajj_packages: "হজ প্যাকেজ ২০২৭",
      umrah: "উমরাহ প্যাকেজ",
      custom: "কাস্টমাইজ প্যাকেজ",
      halal: "হালাল ট্যুর",
      blog: "ব্লগ",
      contact: "যোগাযোগ",
    },
    book_now: "বুক করুন",
    get_quote: "ফ্রি কোটেশন নিন",
    view_details: "বিস্তারিত দেখুন",
    view_all: "সব দেখুন",
    read_more: "আরও পড়ুন",
    enquire: "জিজ্ঞাসা করুন",
    hero: {
      eyebrow: "ফ্লাই জান্নাহ-তে স্বাগতম",
      title: "হজ ও উমরাহর জন্য আপনার বিশ্বস্ত সঙ্গী",
      subtitle:
        "প্রিমিয়াম আবাসন, নিবেদিত দিকনির্দেশনা এবং সম্পূর্ণ মানসিক প্রশান্তির সাথে মক্কা ও মদিনার আধ্যাত্মিক যাত্রা শুরু করুন।",
      cta1: "প্যাকেজ দেখুন",
      cta2: "আমাদের যাত্রা দেখুন",
    },
    stats: {
      travelers: "সন্তুষ্ট হাজী",
      success: "সাফল্যের হার",
      rating: "গ্রাহক রেটিং",
      experience: "বছরের অভিজ্ঞতা",
    },
    about: {
      eyebrow: "আমরা কারা",
      title: "উৎকর্ষতার সাথে ঈমানের যাত্রাকে উন্নত করা",
      body:
        "ফ্লাই জান্নাহ একটি শীর্ষস্থানীয় পবিত্র যাত্রা ভ্রমণ প্রতিষ্ঠান, যা মক্কা ও মদিনার পবিত্র শহরে ব্যতিক্রমী ও আধ্যাত্মিকভাবে সমৃদ্ধ যাত্রা প্রদানে প্রতিশ্রুতিবদ্ধ। বিশ্বাস, পেশাদারিত্ব ও সূক্ষ্ম পরিকল্পনার উপর ভিত্তি করে আমরা প্রতিটি হজ ও উমরাহকে নির্ঝঞ্ঝাট ও স্মরণীয় অভিজ্ঞতায় রূপান্তরিত করি।",
      points: [
        "বিলাসবহুল থেকে সাশ্রয়ী হজ ও উমরাহ প্যাকেজ",
        "হারামের কাছে ৫-তারকা ও প্রিমিয়াম হোটেল",
        "নিবেদিত ভিসা প্রসেসিং ও ডকুমেন্টেশন",
        "ভ্রমণের আগে ও চলাকালীন ২৪/৭ সহায়তা",
        "পেশাদার গ্রাউন্ড হ্যান্ডলিং ও গাইডেড সার্ভিস",
        "পরিবার ও গ্রুপের বিশ্বস্ত সঙ্গী",
      ],
      btn: "আরও জানুন",
    },
    sec: {
      packages_eye: "আপনার প্যাকেজ বেছে নিন",
      packages_title: "আপনার জন্য তৈরি পবিত্র যাত্রা",
      packages_sub:
        "আরাম, সুবিধা ও সম্পূর্ণ প্রশান্তির সমন্বয়ে যত্নসহকারে ডিজাইন করা হজ ও উমরাহ প্যাকেজ।",
      why_eye: "কেন আমরা",
      why_title: "প্রতিটি পবিত্র যাত্রায় উৎকর্ষতা",
      why_sub:
        "আমরা অভিজ্ঞতা, বিশ্বাস ও নিষ্ঠার সমন্বয়ে একটি নির্ঝঞ্ঝাট ও আধ্যাত্মিকভাবে পরিপূর্ণ যাত্রা উপহার দিই।",
      halal_eye: "হালাল ট্যুর",
      halal_title: "হালাল উপায়ে বিশ্ব ঘুরে দেখুন",
      halal_sub:
        "হালাল খাবার, নামাজের সুবিধা ও পারিবারিক আরামসহ মুসলিম-বান্ধব ভ্রমণ গন্তব্য।",
      testi_eye: "প্রশংসাপত্র",
      testi_title: "আমাদের হাজীরা যা বলেন",
      testi_sub:
        "আমাদের হাজীদের আন্তরিক দোয়া ও বিশ্বাস আমাদের উৎকর্ষের প্রতিফলন।",
      blog_eye: "আমাদের ব্লগ",
      blog_title: "দিকনির্দেশনা ও ভ্রমণ তথ্য",
      blog_sub: "আপনার পবিত্র যাত্রার প্রস্তুতির জন্য টিপস, গাইড ও আধ্যাত্মিক তথ্য।",
      affiliations: "আমাদের বিশ্বস্ত পার্টনার",
    },
    why: [
      {
        title: "অভিজ্ঞতা উন্নত করা",
        desc: "হারামের কাছে আরামদায়ক আবাসন থেকে সুসংগঠিত পরিবহন — প্রতিটি বিষয় আপনার প্রশান্তির জন্য পরিচালিত হয়।",
      },
      {
        title: "অতুলনীয় স্থানীয় দক্ষতা",
        desc: "সৌদি আরবে শক্তিশালী অংশীদারিত্ব নির্ভরযোগ্য গ্রাউন্ড হ্যান্ডলিং ও বিশ্বস্ত হোটেল নেটওয়ার্ক নিশ্চিত করে।",
      },
      {
        title: "সম্পূর্ণ ওয়ান-স্টপ সমাধান",
        desc: "ভিসা প্রসেসিং থেকে হোটেল রিজার্ভেশন ও অন-গ্রাউন্ড সহায়তা — সবকিছু আমরা এক ছাদের নিচে পরিচালনা করি।",
      },
      {
        title: "কাস্টমাইজ প্যাকেজ",
        desc: "সাশ্রয়ী, প্রিমিয়াম বা ৫-তারকা বিলাসিতা — আমরা আপনার প্রয়োজন ও বাজেট অনুযায়ী প্যাকেজ ডিজাইন করি।",
      },
    ],
    cta: {
      title: "হজ ও উমরাহতে স্বর্গীয় মুহূর্ত তৈরি করুন",
      body: "একটি আধ্যাত্মিকভাবে রূপান্তরকারী যাত্রার অভিজ্ঞতা নিন যেখানে প্রতিটি বিষয় যত্নসহকারে সাজানো। সম্পূর্ণভাবে আপনার ইবাদত ও আল্লাহর সাথে সংযোগে মনোনিবেশ করুন।",
      btn: "আপনার যাত্রা শুরু করুন",
    },
    from: "শুরু",
    per_person: "প্রতি জন",
    days: "দিন",
    custom: {
      title: "আপনার প্যাকেজ কাস্টমাইজ করুন",
      sub: "আপনার পছন্দ জানান এবং আমাদের ভ্রমণ বিশেষজ্ঞরা আপনার জন্য একটি ব্যক্তিগত হজ বা উমরাহ প্যাকেজ তৈরি করবেন।",
      form: {
        name: "পুরো নাম",
        email: "ইমেইল ঠিকানা",
        phone: "ফোন নম্বর",
        type: "যাত্রার ধরন",
        travelers: "যাত্রীর সংখ্যা",
        depart: "পছন্দের প্রস্থান",
        duration: "সময়কাল (দিন)",
        hotel: "হোটেল ক্যাটাগরি",
        city: "প্রস্থানের শহর",
        budget: "প্রতি জনের বাজেট (টাকা)",
        message: "অতিরিক্ত চাহিদা",
        submit: "অনুরোধ জমা দিন",
      },
      success: "ধন্যবাদ! আমাদের টিম ২৪ ঘণ্টার মধ্যে একটি ব্যক্তিগত কোটেশন নিয়ে আপনার সাথে যোগাযোগ করবে।",
    },
    contact: {
      title: "যোগাযোগ করুন",
      sub: "আপনার যাত্রা নিয়ে প্রশ্ন আছে? আমাদের টিম প্রতিটি পদক্ষেপে আপনাকে সাহায্য করতে প্রস্তুত।",
      address: "ঠিকানা",
      phone: "ফোন",
      email: "ইমেইল",
      hours: "কর্মঘণ্টা",
      form_title: "আমাদের বার্তা পাঠান",
      name: "আপনার নাম",
      msg: "আপনার বার্তা",
      subject: "বিষয়",
      send: "বার্তা পাঠান",
      success: "বার্তা পাঠানো হয়েছে! ইনশাআল্লাহ আমরা শীঘ্রই যোগাযোগ করব।",
    },
    footer: {
      about:
        "ফ্লাই জান্নাহ একটি নির্ঝঞ্ঝাট ও আধ্যাত্মিকভাবে সমৃদ্ধ হজ ও উমরাহ যাত্রার জন্য আপনার বিশ্বস্ত সঙ্গী।",
      quick: "দ্রুত লিঙ্ক",
      packages: "প্যাকেজসমূহ",
      contact: "যোগাযোগের তথ্য",
      newsletter: "নিউজলেটার",
      newsletter_sub: "সর্বশেষ প্যাকেজ ও ভ্রমণ আপডেটের জন্য সাবস্ক্রাইব করুন।",
      subscribe: "সাবস্ক্রাইব",
      rights: "সর্বস্বত্ব সংরক্ষিত।",
      made: "প্রতিটি হাজীর জন্য ভালোবাসা দিয়ে তৈরি।",
    },
    duration: "সময়কাল",
    includes: "যা অন্তর্ভুক্ত",
    filter_all: "সব প্যাকেজ",
    filter_hajj: "হজ",
    filter_umrah: "উমরাহ",
  },
};
